<script>
  import { t } from '../i18n/i18n'
  import { tenantStore, snackBarStore, userStore } from '../state/store'
  import { replace } from 'svelte-spa-router'
  import { request } from '../helpers/api'
  import Button from './Button.svelte'

  const cancelSubscription = async () => {
    if(confirm(`
      We're sorry to see you go!

      This will immediately end your subscription with Contract Keeper.
      Access to this account will be removed for all admins and workers.
      This can not be undone.
    `)) {
      try {
        const response = await request({
          url: '/api/subscriptions',
          method: 'DELETE',
          body: JSON.stringify({
            customerId: $tenantStore._id,
          })
        })

        if (response) {
          sessionStorage.clear()
          userStore.set({})
          replace('/sign-in/')
        }
      } catch (error) {
        snackBarStore.set({ message: $t.something_wrong, type: 'error' })
      }
    }
  }
</script>

<style>
  section > div {
    background: var(--white);
    padding: 2rem 0;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: end;
  }

</style>

<section>
  <h3>{$t.cancel_subscription}</h3>
  <div>
    <Button class="delete" color="cancel" type="button" on:click={cancelSubscription}> {$t.cancel_subscription} </Button>
  </div>
</section>
